import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { RxHamburgerMenu, RxPinLeft } from "react-icons/rx";
import { useUser } from "../contextProviders/userContext";
import { getNavigation } from "./navigationConfig";

function TopNavBar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { user, logout } = useUser();
  const navigation = getNavigation(user?.role);
  const items = [...navigation.primary, ...navigation.secondary];

  const handleLogout = async () => {
    await logout();
    navigate("/signin");
  };

  return (
    <header className="wcco-mobile-nav">
      <div className="wcco-mobile-nav__bar">
        <Link to={navigation.home} aria-label="WCCO dashboard">
          <img className="wcco-mobile-nav__logo" src="/newlogo2.jpg" alt="Wits Citizenship and Community Outreach" />
        </Link>
        <button
          className="wcco-mobile-nav__toggle"
          type="button"
          aria-label={open ? "Close navigation" : "Open navigation"}
          aria-expanded={open}
          aria-controls="mobile-navigation"
          onClick={() => setOpen((value) => !value)}
        >
          <RxHamburgerMenu size={22} aria-hidden="true" />
        </button>
      </div>

      {open && (
        <nav id="mobile-navigation" className="wcco-mobile-nav__panel" aria-label="Mobile navigation">
          <ul className="wcco-nav-list">
            {items.map(({ to, label, icon: Icon, end }) => (
              <li key={to}>
                <NavLink className="wcco-nav-link" to={to} end={end} onClick={() => setOpen(false)}>
                  <Icon size={18} aria-hidden="true" />
                  <span>{label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
          {user?.role === "student" && (
            <button
              className="wcco-mobile-nav-app-btn mt-3 mb-1"
              type="button"
              onClick={() => {
                setOpen(false);
                window.dispatchEvent(new CustomEvent("wcco:open-mobile-prompt"));
              }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                width: "100%",
                padding: "10px 14px",
                border: "1px solid rgba(27, 58, 135, 0.2)",
                borderRadius: "8px",
                backgroundColor: "rgba(27, 58, 135, 0.08)",
                color: "#1B3A87",
                fontSize: "14px",
                fontWeight: 600,
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              <span>📱 Get Mobile App (PWA)</span>
            </button>
          )}
          <button className="wcco-signout mt-2" type="button" onClick={handleLogout}>
            <RxPinLeft size={18} aria-hidden="true" />
            <span>Sign out</span>
          </button>
        </nav>
      )}
    </header>
  );
}

export default TopNavBar;
